import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import '../../../css/scheduledCalls.css';
import MarketBlock from './marketBlock';
import { fetchWithDefaults } from '../../../config/fetchDefault';
import * as amplitude from "@amplitude/analytics-browser";

function LeadsMarket({ data, handleNavigation, setPathData}) {
	const agentInfo = useSelector((state) => state.agent.userData);
    const [newData, setData] = useState(false);
    const [warning, setWarning] = useState(false);

    const gatherData= async()=>{
        try {
            const response = await fetchWithDefaults(`/leadMarketData`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();

            // add LightHouse Lead to top of the type and vendor arrays
            if(jsonData[0].vendors[0] !== undefined && jsonData[0].vendors[0] !== null){
                jsonData[0].vendors[0].unshift({"name":'Lighthouse Leads'})
            }

            if(jsonData[0].types[0] !== undefined && jsonData[0].types[0] !== null){
                jsonData[0].types[0].unshift({"name":'Lighthouse Leads'})
            }

            setData(jsonData);
            setPathData(jsonData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
     }
    useEffect(() => {
        gatherData();
    },[]);

	/**
	 * @param {string} name
	 * @param {boolean} isLeadType
	 */
	const marketBlockOptionClicked = (name, isLeadType) => {
		try {
			amplitude.track(
				isLeadType
					? "Shop Specific Lead Type"
					: "Shop by Vendor",
				{
					"Link Text": name,
					trigger_source: "Market by Type Modal",
					Agent_code: agentInfo.agentCode,
				}
			);
		} catch (err) {
			console.error(
				"marketBlockOptionClicked: Exception occurred during Amplitude communication attempt: %s",
				err,
				err,
			);
		}
		if (name.trim().toLowerCase() === "lighthouse leads") {
			try {
				amplitude.track(
					"Shop Lighthouse Leads",
					{
						"Link Text": "Lighthouse Leads",
						trigger_source: "Market by Type Modal",
						Agent_code: agentInfo.agentCode,
					}
				);
			} catch (err) {
				console.error(
					"marketBlockOptionClicked: Exception occurred during Amplitude communication attempt: %s",
					err,
					err,
				);
			}
		}
		handleNavigation(name);
	}

    return (

        <>
        {newData ? (
            <>
                <MarketBlock adjustclassName={'twoX'} handleNavigation={name => marketBlockOptionClicked(name, true)} title='Lead Types' data={newData[0].types}/>
                <MarketBlock adjustclassName={'twoX'} handleNavigation={name => marketBlockOptionClicked(name, false)} title='Vendors' data={newData[0].vendors}/>
            </>
        ) : (
            null
        )}

        </>
    );
}

export default LeadsMarket;
